/** How a script scrolls: at once when the person asked for reduced motion (WCAG 2.3.3, keyboard walk K8), else smoothly. */
export function scrollMotion(): ScrollBehavior {
  return typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
}
